import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HighchartsChartModule } from 'highcharts-angular';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxColorsModule } from 'ngx-colors';
import { RefreshDataModalComponent } from './refresh-data-modal.component';
import { DataSourceModalComponent } from './data-source-modal.component';
import { DataSourceUploadModalComponent } from './data-source-upload-modal.component';
import { DataDownloadModalComponent } from './data-download-modal.component';
import { ShareReportModalComponent } from './share-report-modal.component';
import { InternalOnlyDirective } from './report-view-mode';
import { EndClientReportPageComponent } from './report-page/end-client-report-page.component';
import { ReportBlockHostComponent } from './report-blocks/report-block-host.component';
import { BarChartBlockComponent } from './report-blocks/bar-chart-block.component';
import { CategoricalDistributionBlockComponent } from './report-blocks/categorical-distribution-block.component';
import { DataTableBlockComponent } from './report-blocks/data-table-block.component';
import { SmallMultiplesBlockComponent } from './report-blocks/small-multiples-block.component';
import { DonutChartBlockComponent } from './report-blocks/donut-chart-block.component';
import { MethodologyBlockComponent } from './report-blocks/methodology-block.component';
import { ExecutiveSummaryBlockComponent } from './report-blocks/executive-summary-block.component';
import { SingleKpiDialBlockComponent } from './report-blocks/single-kpi-dial-block.component';
import { RecommendedActionsBlockComponent } from './report-blocks/recommended-actions-block.component';
import { StackedDistributionBlockComponent } from './report-blocks/stacked-distribution-block.component';
import { SummaryBoxesComponent } from './report-blocks/summary-boxes.component';
import { PieChartBlockComponent } from './report-blocks/pie-chart-block.component';
import { ReportBlockEditorComponent } from './report-blocks/report-block-editor.component';
import { ReportBlockActionsComponent } from './report-blocks/report-block-actions.component';
import { FunnelBlockComponent } from './report-blocks/funnel-block.component';
import { HeadToHeadBlockComponent } from './report-blocks/head-to-head-block.component';
import { RankedDriverBlockComponent } from './report-blocks/ranked-driver-block.component';
import { VerbatimExplorerBlockComponent } from './report-blocks/verbatim-explorer-block.component';
import { ExplainerPanelBlockComponent } from './report-blocks/explainer-panel-block.component';
import { OwnershipHeatmapBlockComponent } from './report-blocks/ownership-heatmap-block.component';
import { RelationshipLadderBlockComponent } from './report-blocks/relationship-ladder-block.component';
import { PositioningScatterBlockComponent } from './report-blocks/positioning-scatter-block.component';
import { WordCloudBlockComponent } from './report-blocks/word-cloud-block.component';
import { HeatmapBlockComponent } from './report-blocks/heatmap-block.component';
import { TextBlockComponent } from './report-blocks/text-block.component';
import { ImageBlockComponent } from './report-blocks/image-block.component';
import { MultiMarketBlockComponent } from './report-blocks/multi-market-block.component';
import { ReportConfigHintComponent } from './report-blocks/report-config-hint.component';
import { ReportChatComponent } from './report-chat/report-chat.component';
import { ReportHistoryComponent } from './report-history/report-history.component';
import { ReportHistoryModalComponent } from './report-history/report-history-modal.component';
import { ReportSelectComponent } from './report-select.component';
import { ThemePickerComponent } from './theme-picker/theme-picker.component';
import { ThemePreviewComponent } from './theme-preview/theme-preview.component';
import { ReportStatisticsComponent } from './report-statistics.component';
import { ReportStatisticsModalComponent } from './report-statistics-modal.component';
import { ModuleGuideModalComponent } from './module-guide-modal.component';

@NgModule({
  declarations: [
    EndClientReportPageComponent,
    ReportBlockHostComponent,
    BarChartBlockComponent,
    CategoricalDistributionBlockComponent,
    DataTableBlockComponent,
    SmallMultiplesBlockComponent,
    PieChartBlockComponent,
    DonutChartBlockComponent,
    MethodologyBlockComponent,
    ExecutiveSummaryBlockComponent,
    SingleKpiDialBlockComponent,
    RecommendedActionsBlockComponent,
    StackedDistributionBlockComponent,
    SummaryBoxesComponent,
    ReportBlockEditorComponent,
    ReportBlockActionsComponent,
    FunnelBlockComponent,
    HeadToHeadBlockComponent,
    RankedDriverBlockComponent,
    VerbatimExplorerBlockComponent,
    WordCloudBlockComponent,
    HeatmapBlockComponent,
    TextBlockComponent,
    ImageBlockComponent,
    PositioningScatterBlockComponent,
    OwnershipHeatmapBlockComponent,
    RelationshipLadderBlockComponent,
    ExplainerPanelBlockComponent,
    MultiMarketBlockComponent,
    ReportConfigHintComponent,
    ReportChatComponent,
    ReportHistoryComponent,
    ReportHistoryModalComponent,
    ReportSelectComponent,
    RefreshDataModalComponent,
    DataSourceModalComponent,
    DataSourceUploadModalComponent,
    DataDownloadModalComponent,
    ShareReportModalComponent,
    InternalOnlyDirective,
    ThemePickerComponent,
    ThemePreviewComponent,
    ReportStatisticsComponent,
    ReportStatisticsModalComponent,
    ModuleGuideModalComponent,
  ],
  imports: [CommonModule, FormsModule, RouterModule, HighchartsChartModule, TooltipModule.forRoot(), ModalModule, NgxColorsModule, BsDropdownModule.forRoot()],
  // The modal is exported so the reports list in `main` can open the same one the deck does --
  // the choice and its warning have to read identically wherever a refresh is started.
  exports: [
    EndClientReportPageComponent,
    RefreshDataModalComponent,
    DataSourceModalComponent,
    DataSourceUploadModalComponent,
    ShareReportModalComponent,
    InternalOnlyDirective,
    // NK-450: the create-report and template modals in `main` pick a theme with the same control
    // the deck editor uses; the theme editor there previews with the real deck.
    ThemePickerComponent,
    ThemePreviewComponent,
  ]
})
export class EndClientReportingModule { }
